import React from 'react';

import { useStaticQuery, graphql } from 'gatsby';

import { useIntl } from '../../../../plugins/publicis-gatsby-plugin-i18n';
import { ArrowIconGoRight, LineBlackBannerHome, LogoColasBlack } from '../../../Atoms/Icons/Icons';
import useMedias from '../../../hooks/useMedias';

import './BannerHome.scss';
import { trackInnovationEvents } from '../../../Utils/Tracking';
import { removeHtmlTag } from '../../../Utils/Utils';

const BannerHome = ({ imagesArray }) => {
  const intl = useIntl();
  const locale = intl.locale;
  const { getImage } = useMedias();

  const data = useStaticQuery(graphql`
    query bannerHome {
      evenBannerData :   allBlockContentBlockBanniereEvenementielle {
        edges {
          node {
            body {
              processed
            }
            field_lien {
              title
              url
            }
            field_display_logo
            field_display
            langcode
            relationships {
              field_image {
                drupal_internal__mid
              }
            }
          }
        }
      }
      

    }
  `);
  const eventBannerData = data?.evenBannerData?.edges?.filter(({ node: x }) => x.langcode === locale)[0]?.node;
  const pictoBannerHome = getImage(
    imagesArray,
    eventBannerData?.relationships?.field_image?.drupal_internal__mid
  )?.image_style_uri?.gatsby_thumbnail;

  let bannerCTALink = eventBannerData?.field_lien?.url;
  if (
    eventBannerData?.field_lien?.url?.indexOf('/pdf/?file=') < 0 &&
    eventBannerData?.field_lien?.url?.indexOf('.pdf') > 0
  ) {
    bannerCTALink = process.env.GATSBY_METADATA_SITE_URL + intl.locale + '/pdf/?file=' + eventBannerData?.field_lien?.url + '&title=' + removeHtmlTag(eventBannerData?.field_lien?.title || '')
  }

  return (
    <div className="banner_home_container" style={{ display: !eventBannerData?.field_display ? 'none' : null }}>
      <div className="banner_logo_text">
        <div className="logo_text">
          {
            eventBannerData?.field_display_logo &&
            <>
              <LogoColasBlack />
              <LineBlackBannerHome customClass="black_line" />
            </>
          }
          <img loading="lazy" width="82" height="108" className="picto" src={pictoBannerHome} alt="" />
          {/* <PictoBannerHome  /> */}
        </div>
        <div className="text_content" dangerouslySetInnerHTML={{ __html: eventBannerData?.body?.processed }}>
        </div>
      </div>
      <div className="btn_container">
        <a
          href={bannerCTALink}
          className="button_banner"
          onClick={() => {
            trackInnovationEvents(
              {
                event: 'clic_cta_banniere_event',
                page_name: 'accueil',
                page_type: 'home',
                zone: 'bandeau_evenementiel',
                button_content: eventBannerData?.field_lien?.title,
                button_type: 'cta'
              }
            )
          }}>
          {eventBannerData?.field_lien?.title}
          <ArrowIconGoRight />
        </a>
      </div>
    </div>
  );
};

export default BannerHome;
